import axios from "axios";

// 第四种简写:返回的本身是Promise,没必要再自己包装一遍
export function request(config) {
  // 1.创建axios实例
  const instance =axios.create({
    baseURL:'http://www-admin.jnshukedu.com/prod-api/web',
      //  baseURL:'http://192.168.8.151:8080/web', //广乐
    timeout:5000
  })
  // axios的拦截器
  // 2.1请求拦截的作用
  instance.interceptors.request.use(config =>{

//    1.比如config中的一些信息不符合服务器的要求，必须经过变化之后再给服务器传过去
//    2.比如每次发送网络请求时，都希望在界面中显示一个请求的图标：加载图标（显示、隐藏）
//    3.某些网络请求（比如登录（token）），必须携带一些特殊的信息
      return config  //这里必须返回,不然拿不到config
    }, err =>{

    }
  )
  // 2.2响应拦截
  instance.interceptors.response.use(res=>{

    return res.data
  },err => {

  })
  // 3.发送真正的网络请求
  return instance(config)
}



// WEBPACK FOOTER //
// ./src/network/request.js